// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import {
	FLYOUT_MENU_CONTENT_ID,
	BOARD_CREATE_PACKAGE_NAME,
	TEAM_NAME,
} from './boardTypes.constants.tsx';
import type { BoardCreateFlyoutMenuProps } from './BoardCreateFlyoutMenuProps.types.tsx';
import { flyoutMenuContentEntryPoint } from './flyoutMenuContentEntryPoint.entrypoint.tsx';
import { FlyoutMenuContentFallback } from './FlyoutMenuContentFallback.tsx';

const entryPointParams = {};

export const AsyncFlyoutMenuContent = (
	props: Omit<BoardCreateFlyoutMenuProps, 'renderTrigger'>,
): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		flyoutMenuContentEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id={FLYOUT_MENU_CONTENT_ID}
			packageName={BOARD_CREATE_PACKAGE_NAME}
			teamName={TEAM_NAME}
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<FlyoutMenuContentFallback />}
			errorFallback="flag"
			runtimeProps={props}
		/>
	);
};
